@for (question of gradingQuestions() | sortBy: 'suggestedSortingOrder'; track question.question) {
  <form class="condition-question-container" [formGroup]="tradeInConditionForm">
    <p>{{ question.question }}</p>
    <div class="condition-form-group">
      @for (alternative of question.answerAlternatives | sortBy: 'suggestedSortingOrder'; track $index) {
        <app-ice-radio-button
          ngDefaultControl
          testId="condition-input"
          [forId]="alternative.displayValue + question.questionType"
          [formControlName]="question.questionType"
          [isBoxVersion]="true"
          [label]="alternative.displayValue"
          [value]="alternative.answer"
        />
      }
    </div>
    <app-information-button
      [activeLabel]="'Skjul informasjon'"
      [inactiveLabel]="'Mer informasjon'"
      (toggleInfo)="toggleActiveInformation(question.questionType)"
    />
  </form>
}
